import { useTranslation } from 'react-i18next'
import PolicyLink from './PolicyLink'

// The project's own Facebook page — the retention half of the growth loop, since
// visitors arrive *from* FB groups. Set to '' to render no link at all.
const FACEBOOK_PAGE_URL = 'https://www.facebook.com/provjericijene.hr'

export default function Footer() {
  const { t } = useTranslation()
  // Prefilled "report a wrong price" email — a visible trust path, so shelf-vs-
  // crawl drift reaches us before it becomes a Facebook thread.
  const reportHref = `mailto:info@infinapps.com?subject=${encodeURIComponent(
    t('footer.reportSubject'),
  )}&body=${encodeURIComponent(t('footer.reportBody'))}`
  return (
    <footer className="px-4 py-3.5 text-center text-xs leading-relaxed text-faint border-t border-line mt-8">
      <p className="mb-1.5">{t('footer.disclaimer')}</p>
      {/* Links + attribution on a single quiet line. The open-source crawler
          credit lives on the Terms page ("Izvor podataka"), not here — the
          scanner screen should read as a tool, not a content section. */}
      <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <PolicyLink to="/privatnost" className="text-faint hover:text-muted underline underline-offset-2">{t('footer.privacy')}</PolicyLink>
        <span aria-hidden="true">·</span>
        <PolicyLink to="/uvjeti" className="text-faint hover:text-muted underline underline-offset-2">{t('footer.terms')}</PolicyLink>
        <span aria-hidden="true">·</span>
        <a href={reportHref} className="text-faint hover:text-muted underline underline-offset-2">{t('footer.reportPrice')}</a>
        {FACEBOOK_PAGE_URL && (
          <>
            <span aria-hidden="true">·</span>
            {/* Text-only, no FB glyph: it would be the sole icon on this line, and
                a blue brand mark fights the text-faint palette. The word reads
                better than a glyph for the older audience this app is built for. */}
            <a
              href={FACEBOOK_PAGE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-faint hover:text-muted underline underline-offset-2"
            >
              {t('footer.facebook')}
            </a>
          </>
        )}
        <span aria-hidden="true">·</span>
        <a href="https://infinapps.com" target="_blank" rel="noopener noreferrer" className="text-faint hover:text-muted underline underline-offset-2">Infinapps</a>
      </p>
    </footer>
  )
}
